import bikeJSON from '../data/data';
import Bike from './Bike';
import Range from './Range';

import { UNITS } from '../constants/units';

export default class SearchService  {

    constructor() {
        this.bikes = bikeJSON.bikes;
        this.heightRange = [];
    }

    getBike(source) {
        const { id, type, heightInch, folder, colors, wheel } = source;

        return new Bike(id, type, heightInch, folder, colors, wheel);  
    }    

    // Returns bike suits to filter options
    matchBike(filter) {
        const height = filter.unit === UNITS.inches ? parseInt(filter.height, 10) : parseInt(filter.height / UNITS.factor.inches, 10);    
        const bikeResult = this.bikes.filter(bike => Number(height) === Number(bike.heightInch))[0];
        const bike = bikeResult ? bikeResult : this.bikes[0];

        return this.getBike(bike);

    }

    // Returns bike with initial props
    defaultBike() {
        return this.getBike(this.bikes[0]) 
    }

    // Return recommendation of next bike after child will growth
    getNext(bike) {
        const currentWheel = bike.wheel;
        const wheelsAll = this.bikes.map(bike => bike.wheel);
        // unique collection of wheels
        const wheels = [...new Set(wheelsAll)];
        const nextBikeArray = wheels.filter(wheel => wheel > currentWheel);

        return nextBikeArray.length ? `${nextBikeArray[0]} inch bike` : 'max bike size'
        
    }

    // Initial props object
    getFirstImages() {
        return this.bikes.map(bike => ({
            "wheel": bike.wheel, 
            "color": bike.colors[0], 
            "folder": bike.folder, 
            "type": bike.type
        }))
    }

    lastBike() {       
        return this.getBike(this.bikes[this.bikes.length - 1]) 
    }

    // Returns range slider height params 
    getHeightRange() {
        this.bikes.map(bike => this.heightRange.push(bike.heightInch));

        return new Range(Math.min(...this.heightRange), Math.max(...this.heightRange) )
    }

};




// WEBPACK FOOTER //
// ./src/classes/SearchService.js